export const USER_SERVICE = {
  ROLES: '/user-service/roles',
  EDIT_USERS: '/user-service/roleAssignment/editUsers',
  LOGGED_IN_ROUND_ROBIN: '/user-service/round-robin/titles/all-round-robin-users',
};



export enum SERVICES {
  ACCOUNTING = 'accounting-service',
  ASSET = 'asset-service',
  CONTACT = 'contact-service',
  DEAL = 'deal-service',
  DOCUMENT = 'document-service',
  DIALER = 'dialer-service',
  LEAD = 'lead-service',
  LENDER = 'lender-service',
  PRODUCT = 'product-service',
  SEARCH = 'search-service',
  USER = 'user-service',
  WORKFLOW = 'workflow-service',
  COMMUNICATION = 'communication-service',
  CONFIGURATION = 'configuration-service',
  NOTIFICATION = 'notification-service',
  PAYMENT = 'payment-service',
  APICOMPOSER = 'apicomposer-service',
  OPENLENDING = 'open-lending',
  CONSENT = 'consent-service',
  PURL ='purl-service',
  EXTERNAL='externalapi-service',
 
}

export const EC_SERVICE = {
  ENTERPRISECOMMUNICATION: `${process.env.REACT_APP_EC_API_URL}/ec-service`,
};